import script from "./FloatingWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&setup=true&lang=js"

import "./FloatingWindow.vue?vue&type=style&index=0&id=1872aba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1872aba4"]])

export default __exports__